export enum InvoiceForEmployer {
  Yes = 'yes',
  No = 'no',
  Unclear = 'unclear',
}
